import { locale as localeConfig } from '@adsk/au-common-js';

export function generatePlaylistPathname(id: string, language?: string) {
  const langPrefix = localeConfig.generateLanguagePrefix(
    language || localeConfig.defaultURLLocale
  );

  return `/autodesk-university${langPrefix}/playlist/${id}`;
}
